import { useAppSelector } from 'shared';

export const useCulinaryStudioArticlePageState = () => useAppSelector(
    (store) => store.culinaryStudioArticlePage,
);
